import { createSelector } from 'reselect';
import { VasState } from '../../store/store-type';

export const getState = (state: VasState) => state.calendar;

export const getDates = createSelector(
    getState,
    state => state.dates
);
export const getStartDate = createSelector(
    getState,
    state => state.startDate
);

export const getLoading = createSelector(
    getState,
    state => state.loading
);

export const getDayNames = createSelector(
    getDates,
    dates => dates.slice(0, 7).map(date => date.date.format('ddd'))
);

export const getWeeks = createSelector(
    getDates,
    dates => {
        const count = dates.length / 7;
        const weeks = [];
        for (let i = 0; i < count; i++) {
            weeks.push(dates.slice(i * 7, (i * 7) + 7));
        }
        return weeks;
    }
);



// WEBPACK FOOTER //
// ./src/vas/pages/job-calendar/calendar.selectors.ts